import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from '@core/config.service';
import { HttpClient } from '@angular/common/http';
import { LocaleService } from '@app/services/locale/locale.service';

declare const window: any;

@Component({
  selector: 'pixie-dvic-banner',
  templateUrl: './dvic-banner.component.html',
  styleUrls: ['./dvic-banner.component.scss']
})

export class DvicBannerComponent implements OnInit {

    preferredLanguage;
    geolocation;
    bannerOverride;
    dvicToggle;
    tokenCookie;
    authToken;
    webOrMobile;
    globalSiteId;
    environment;
    dvicScript;
    dvicimage;

  constructor(
      private cookieService: CookieService,
      private configService: ConfigService,
      private httpClient: HttpClient,
      private localeService: LocaleService,
    ) { }

  ngOnInit() {
        if (window.screen.width <= 480) {
            this.webOrMobile = 'mobile_web';
        } else {
            this.webOrMobile = 'web';
        }
        this.globalSiteId = 'dcl';
        this.dvicBanner();
    }

    dvicBanner() {
        if (this.cookieService.get('localeCookie_jar')) {
            this.preferredLanguage = JSON.parse(decodeURIComponent(this.cookieService.get('localeCookie_jar')))['preferredRegion'];
        }
        if (this.cookieService.get('languageSelection_jar_aka')) {
            const cookie = this.cookieService.get('languageSelection_jar_aka');
            this.preferredLanguage = JSON.parse(decodeURIComponent(cookie))['preferredLanguage'];
        }
        if (this.cookieService.get('GEOLOCATION_jar')) {
            this.geolocation = JSON.parse(decodeURIComponent(this.cookieService.get('GEOLOCATION_jar')))['countryisocode'];
        }
        const locale = this.preferredLanguage || this.localeService.getLocale() || 'en';
        // this.preferredLanguage = 'en_US'; // FOR TESTING ONLY

        if (this.globalSiteId === 'dcl' && locale === 'en' && this.geolocation === 'USA') {
            this.readBannerToggle();
            return locale;
        }
        if (locale === 'en_US' || locale === 'en') {
            this.readBannerToggle();
            return locale;
        }
    }

    readBannerToggle() {
        this.httpClient.get('https://stage.cdn1.parksmedia.wdprapps.disney.com/media/home/homepage-banner-toggles.json').subscribe(json => {
            this.environment = this.configService.getValue('environment');
            // this.environment = 'stage'; // FOR TESTING ONLY

            const bannerOverride = this.cookieService.get('dvicBannerToggle');
            if (bannerOverride) {
                const override = bannerOverride.split(',');
                if (override[0] === this.globalSiteId && override[1] === this.environment && override[2] === 'off') {
                    console.log('dvic turned off');
                    return;
                }
            }
            this.tokenCookie = this.cookieService.get('tokenSwid');
            if (this.tokenCookie) {
                this.showDvicBanner();
                return;
            }
            const showimage = this.cookieService.get('showbannnerimage');
            if (showimage) {
                this.showDvicBannerImage();
                return;
            }
            this.dvicToggle = json;
            if (this.dvicToggle[this.globalSiteId][this.environment] === 'on') {
                this.showDvicBanner();
                return;
            }
            if (this.dvicToggle[this.globalSiteId][this.environment] === 'off') {
                this.showDvicBannerImage();
                return;
            }
        }, error => { throw error; });
    }

    public showDvicBanner() {
        let token;
        if (this.tokenCookie) {
            token = this.tokenCookie.split(',')[0];
        }
        if (!token) {
            this.httpClient.get('/authentication/get-client-token/').subscribe(json => {
                console.log(json);
                this.authToken = json['access_token'];
                this.dvicBannerCall();
            }, error => {
                console.log('error: could not get authentication token');
                console.log(error);
            });
        } else {
            this.authToken = token;
            this.dvicBannerCall();
        }
    }

    showDvicBannerImage() {
        if (this.webOrMobile ===  'mobile_web') {
           // use mobile photo
           this.dvicimage = 'mobile_web';
        } else {
            // use desktop photo
            this.dvicimage = 'web';
        }
    }

    dvicBannerCall() {
        let myswid;
        let userProfile;
        if (this.cookieService.get('rememberme')) {
            try {
                userProfile = JSON.parse(this.cookieService.get('rememberme'));
                if (userProfile.swid) {
                    myswid = userProfile.swid;
                }
            } catch (error) {
                console.log(error);
            }
        }
        if (this.tokenCookie) {
            const swid = this.tokenCookie.split(',');
            if (swid.length > 1) {
                myswid = swid[1];
            }
        }
        if (this.environment === 'latest') {
            this.dvicScript = 'https://latest.cdn1.parksmedia.wdprapps.disney.com/media/dvic-banner/'
            + this.globalSiteId + '/wdpr-dvic-banner.js';
        } else if (this.environment === 'stage') {
            this.dvicScript = 'https://stage.cdn1.parksmedia.wdprapps.disney.com/media/dvic-banner/'
            + this.globalSiteId + '/wdpr-dvic-banner.js';
        } else {
            this.dvicScript = 'https://cdn1.parksmedia.wdprapps.disney.com/media/dvic-banner/'
            + this.globalSiteId + '/wdpr-dvic-banner.js';
        }

        const script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'dvicBannerEmbedScript';
            script.async = true;
            script.src = this.dvicScript;
            document.getElementsByTagName('body')[0].appendChild(script);

        window.onReadyDvicBanner = function() {
            console.log('banner ready');
            window.dvicBanner
                .configuration({
                apiPrefixPath: '/dvic', // remove when testing locally
                serviceTimeout: 5000,
                accessToken: this.authToken,
                envName: this.environment, // 'latest'
                params: {
                    siteId: this.globalSiteId, // 'dcl'
                    pageId: 'home',
                    device: this.webOrMobile,
                    swid: myswid
                }
            })
            .init();
            window.dvicBanner.loadBanner()
                .then(function(bannerData) {
                console.log('bannerData');
                console.log(bannerData);
                if (window.WDPRO.Analytics.Framework.trackElement
                    && document.getElementById('wdpr-dvic-banner')
                    && bannerData.hasOwnProperty('analytics') !== undefined) {
                    if (bannerData.analytics.hasOwnProperty('impression')) {
                        console.log('analytics available');
                        window.WDPRO.Analytics.Framework.trackElement(bannerData.analytics.impression, this.webOrMobile);
                        window.onDvicBannerClick = function(data) {
                            if (data.hasOwnProperty('analytics') && data.analytics.hasOwnProperty('click')) {
                                window.WDPRO.Analytics.Framework.trackElement(data.analytics.click, this.webOrMobile);
                            }

                            if (typeof data.redirectLink !== 'undefined') {
                                window.location.href = data.redirectLink;
                            }
                        }.bind(this);
                    }
                }
            }.bind(this));
        }.bind(this);
    }

}
